export const QUESTION_NAME_MAX_LENGTH = 254;
